import React from "react";
import { Modal } from "antd";

const InputModal = ({ visible, footer, title, children }) => {
	return (
		<Modal
			open={visible}
			title={title}
			footer={footer}
			maskClosable={false}
			closable={false}
			destroyOnClose={true}
		>
			{children}
		</Modal>
	);
};

export default InputModal;
